import { ADDRESS_FIELD_NAMES } from './actionTypes';

export const selectAddressState = (state) => state.address;

export const selectAddressFields = (state) => state.address.fields;

export const selectAddressField = (state, fieldName) => state.address.fields[fieldName];

export const selectIsCountriesFetching = (state) => state.address.isFetching;

export const selectCountries = (state) => state.address.countriesList;

export const selectIsJuridic = (state) => state.address.fields[ADDRESS_FIELD_NAMES.IS_JURIDIC];

export const selectFormErrors = (state) => {
    const fields = state.address.fields;
    const errors = {};

    if (!fields[ADDRESS_FIELD_NAMES.FIRSTNAME]) {
        errors[ADDRESS_FIELD_NAMES.FIRSTNAME] = 'обязательно для заполнения';
    } else if (!fields[ADDRESS_FIELD_NAMES.FIRSTNAME].match(/^[a-zA-Zа-яА-ЯёЁ\-\s]+$/)) {
        errors[ADDRESS_FIELD_NAMES.FIRSTNAME] = 'допускаются буквы, пробел и дефис';
    }

    if (!fields[ADDRESS_FIELD_NAMES.LASTNAME]) {
        errors[ADDRESS_FIELD_NAMES.LASTNAME] = 'обязательно для заполнения';
    } else if (!fields[ADDRESS_FIELD_NAMES.LASTNAME].match(/^[a-zA-Zа-яА-ЯёЁ\-\s]+$/)) {
        errors[ADDRESS_FIELD_NAMES.LASTNAME] = 'допускаются буквы, пробел и дефис';
    }

    if (!fields[ADDRESS_FIELD_NAMES.PHONE]) {
        errors[ADDRESS_FIELD_NAMES.PHONE] = 'обязательно для заполнения';
    } else if (fields[ADDRESS_FIELD_NAMES.PHONE].indexOf('_') >= 0) {
        errors[ADDRESS_FIELD_NAMES.PHONE] = 'введите номер полностью';
    }

    if (fields[ADDRESS_FIELD_NAMES.EMAIL]) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(fields[ADDRESS_FIELD_NAMES.EMAIL])) {
            errors[ADDRESS_FIELD_NAMES.EMAIL] = 'неверный формат эл.почты';
        }
    }

    if (fields[ADDRESS_FIELD_NAMES.IS_JURIDIC]) {
        if (!fields[ADDRESS_FIELD_NAMES.COMPANY]) {
            errors[ADDRESS_FIELD_NAMES.COMPANY] = 'обязательно для заполнения';
        }

        if (!fields[ADDRESS_FIELD_NAMES.COMPANY_JOB_TITLE]) {
            errors[ADDRESS_FIELD_NAMES.COMPANY_JOB_TITLE] = 'обязательно для заполнения';
        }

        if (fields[ADDRESS_FIELD_NAMES.COMPANY_INN] && !/^\d{10}$/.test(fields[ADDRESS_FIELD_NAMES.COMPANY_INN])) {
            errors[ADDRESS_FIELD_NAMES.COMPANY_INN] = 'ИНН должен содержать 10 цифр';
        }

        if (fields[ADDRESS_FIELD_NAMES.COMPANY_KPP] && !/^\d{9}$/.test(fields[ADDRESS_FIELD_NAMES.COMPANY_KPP])) {
            errors[ADDRESS_FIELD_NAMES.COMPANY_KPP] = 'КПП должен содержать 9 цифр';
        }

        if (fields[ADDRESS_FIELD_NAMES.COMPANY_OGRN] && !/^\d{13}$/.test(fields[ADDRESS_FIELD_NAMES.COMPANY_OGRN])) {
            errors[ADDRESS_FIELD_NAMES.COMPANY_OGRN] = 'ОГРН должен содержать 13 цифр';
        }
    }

    return errors;
};

export const selectHasFormErrors = (state) => {
    const errors = selectFormErrors(state);
    return Object.keys(errors).length > 0;
};

export const addressSelectors = {
    selectAddressState,
    selectAddressFields,
    selectAddressField,
    selectIsCountriesFetching,
    selectCountries,
    selectIsJuridic,
    selectFormErrors,
    selectHasFormErrors,
};